module.exports = __webpack_public_path__ + "img/exhibits6.91c52119.png";